module.exports = __webpack_public_path__ + "static/media/pcb_finalne-2-z-cieniem.d7eac4c1.svg";